export const PREDEFINED_RATIOS = {
  square: 1,
  portrait: 3 / 4,
  cinema: 16 / 9,
  landscape: 4 / 3,
  none: 'none',
};
